/* Mega-menu variant B.
   Drie stappen: producttype -> merk -> model (Merken-paneel: merk -> model -> product).
   Desktop: de stappen naast elkaar als kolommen, keuze volgt hover.
   Mobiel: één stap per scherm, vooruit door te tappen, terug via de knop.

   Waar de laatste stap niets te kiezen heeft, schuift de inhoud een kolom naar
   voren en blijft de laatste kolom weg — geen lege vakken met een melding.
   Stap 1 staat in de HTML (crawlbaar); stap 2 en 3 komen uit de databron.
   Er wordt niets getoond waarvoor geen collectie bestaat. */
(function () {
  'use strict';

  var el = document.getElementById('mmb-data');
  if (!el) return;

  var data;
  try { data = JSON.parse(el.textContent); } catch (e) { return; }

  var mobile = window.matchMedia('(max-width: 768.98px)');

  /* ---------------------------------------------- actieve staat in de balk
     Het thema onderstreept een menu-item alleen als de pagina in het hoofdmenu
     van de shop staat. De panelen bereiken veel meer collecties, en die handles
     staan hier al in de databron. Dus zoeken we het huidige pad daarin op en
     markeren het bijbehorende menu-item zelf.

     Alleen als het thema nog niets gemarkeerd heeft, zodat er nooit twee
     items onderstreept staan. */
  function bevatHandle(node, handle) {
    if (!node || typeof node !== 'object') return false;
    if (Array.isArray(node)) {
      for (var i = 0; i < node.length; i++) {
        if (bevatHandle(node[i], handle)) return true;
      }
      return false;
    }
    // alleen h en r zijn collectie-handles; l is een label of een lijst links
    if (node.h === handle || node.r === handle) return true;
    for (var k in node) {
      if (typeof node[k] === 'object' && bevatHandle(node[k], handle)) return true;
    }
    return false;
  }

  (function markeerActief() {
    var pad = location.pathname.match(/\/collections\/([^/?#]+)/);
    if (!pad) return;
    if (document.querySelector('.main-nav__item--primary.is-active')) return;

    var panels = document.querySelectorAll('[data-mmb-panel]');

    function markeer(el) {
      var d = el.closest('details');
      var link = d && d.querySelector('.main-nav__item--primary');
      if (!link) return false;
      link.classList.add('is-active');
      link.setAttribute('aria-current', 'true');
      return true;
    }

    /* Elke merk- of modelcollectie zit ook in het Merken-paneel. Zou dat
       meetellen, dan stond Merken bijna altijd onderstreept. Dus eerst de
       categorieën, en Merken alleen als geen enkele categorie het bevat. */
    var merkenPaneel = null;
    for (var i = 0; i < panels.length; i++) {
      var naam = panels[i].getAttribute('data-mmb-panel');
      if (naam === 'Merken') { merkenPaneel = panels[i]; continue; }
      // dezelfde bronkeuze als fill2/fill3
      var bron = (data.c || {})[naam] || (data.u || {})[naam];
      if (bevatHandle(bron, pad[1]) && markeer(panels[i])) return;
    }
    if (merkenPaneel && bevatHandle(data.m, pad[1])) markeer(merkenPaneel);
  })();

  // Basispad voor collecties komt uit de server-side gerenderde stap 1, zodat
  // een taal- of marktprefix in de URL meegaat.
  var BASE = (function () {
    var a = document.querySelector('.mmb__row[href*="/collections/"]');
    if (!a) return '/collections/';
    var m = a.getAttribute('href').match(/^(.*\/collections\/)/);
    return m ? m[1] : '/collections/';
  })();

  var CHEV = '<svg class="mmb__chev" aria-hidden="true" viewBox="0 0 24 24" fill="none"' +
    ' stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="m9 18 6-6-6-6"/></svg>';

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* Rij die de volgende stap opent. Bestaat er ook een collectie voor deze
     keuze, dan is het een echte link: op desktop navigeert de klik, op touch
     opent de tap eerst de volgende stap. */
  function row(label, index, handle) {
    if (handle) {
      return '<a class="mmb__row" role="tab" aria-selected="false"' +
        ' href="' + BASE + esc(handle) + '" data-mmb-pick="' + index + '">' +
        esc(label) + CHEV + '</a>';
    }
    return '<button type="button" class="mmb__row" role="tab" aria-selected="false"' +
      ' data-mmb-pick="' + index + '">' + esc(label) + CHEV + '</button>';
  }

  /* rij zonder vervolgstap: gaat rechtstreeks naar de collectie */
  function leaf(label, handle, index) {
    return '<a class="mmb__row mmb__row--leaf" href="' + BASE + esc(handle) + '"' +
      ' data-mmb-leaf="' + index + '">' + esc(label) + '</a>';
  }

  function link(label, handle) {
    return '<a class="mmb__link" href="' + BASE + esc(handle) + '">' + esc(label) + '</a>';
  }

  function allLink(label, handle) {
    return '<a class="mmb__all" href="' + BASE + esc(handle) + '">' +
      '<span class="mmb__all-text">' + esc(label) + '</span> &rarr;</a>';
  }

  function initPanel(panel) {
    var name = panel.dataset.mmbPanel;
    var isBrands = name === 'Merken';
    var entries = isBrands ? data.m : (data.c || {})[name];

    var inner = panel.querySelector('.mmb__inner');
    var col1 = panel.querySelector('[data-mmb-step="1"]');
    var col2 = panel.querySelector('[data-mmb-step="2"]');
    var col3 = panel.querySelector('[data-mmb-step="3"]');
    if (!entries || !col1 || !col2 || !col3) return;

    var rows1 = col1.querySelector('.mmb__rows');
    var rows2 = col2.querySelector('[data-mmb-rows]');
    var rows3 = col3.querySelector('[data-mmb-rows]');
    var title2 = col2.querySelector('[data-mmb-title]');
    var title3 = col3.querySelector('[data-mmb-title]');
    var back2 = col2.querySelector('[data-mmb-back-label]');
    var back3 = col3.querySelector('[data-mmb-back-label]');
    var count = col2.querySelector('[data-mmb-count]');
    var attr1 = isBrands ? 'mmbBrand' : 'mmbType';

    var canHover = window.matchMedia('(hover: hover)').matches;
    var state = { a: 0, b: 0, step: 1 };

    /* Op desktop met cursor heeft hover de volgende kolom al gevuld, dus mag
       de klik doen wat de link belooft. Op touch is de tap de enige manier
       om verder te komen. */
    function followLink(t) {
      return t.tagName === 'A' && canHover && !mobile.matches;
    }

    /* Sommige producttypes zijn niet merkgebonden (deursloten, ventilatie).
       Die hebben geen merkkolom; de rij in stap 1 is dan zelf de bestemming. */
    function hasStep2() {
      var e = entries[state.a];
      if (!e) return false;
      return isBrands ? e.d.length > 0 : e.b.length > 0;
    }

    /* Heeft de huidige keuze nog een derde stap? Zo niet, dan staat alles al
       in kolom 2 en blijft kolom 3 weg. */
    function hasStep3() {
      var e = entries[state.a];
      if (!e) return false;
      if (isBrands) {
        // een model kan een eigen collectie hebben zonder aparte producttypes;
        // dan is de modelrij zelf de bestemming en blijft stap 3 weg
        if (!e.d.length) return false;
        var mo = e.d[Math.min(state.b, e.d.length - 1)];
        return !!(mo && mo.t.length);
      }
      var br = e.b[state.b];
      return !!(br && br.d.length > 0);
    }

    function mark(container, index) {
      var rs = container.querySelectorAll('[role="tab"]');
      for (var i = 0; i < rs.length; i++) {
        var v = rs[i].dataset.mmbPick !== undefined
          ? Number(rs[i].dataset.mmbPick) : Number(rs[i].dataset[attr1]);
        rs[i].setAttribute('aria-selected', String(v === index));
      }
    }

    /* kolommen verbergen die niets te tonen hebben */
    function syncCols() {
      var two = hasStep2();
      var three = two && hasStep3();
      inner.setAttribute('data-mmb-cols', !two ? '1' : (three ? '3' : '2'));
      if (!three) { rows3.innerHTML = ''; if (title3) title3.textContent = ''; }
      if (!two) { rows2.innerHTML = ''; if (count) count.textContent = ''; }
    }

    function showStep(n) {
      if (n === 3 && !hasStep3()) n = 2;
      if (n === 2 && !hasStep2()) n = 1;
      state.step = n;
      if (!mobile.matches) return;
      [col1, col2, col3].forEach(function (c, i) {
        if (i + 1 === n) c.setAttribute('data-mmb-active', '');
        else c.removeAttribute('data-mmb-active');
      });
      var sc = panel.closest('.main-nav__child');
      if (sc) sc.scrollTop = 0;
    }

    function fill2() {
      var e = entries[state.a];
      if (!e) return;
      if (!hasStep2()) { syncCols(); return; }
      var html = '', i;

      if (isBrands) {
        if (e.d.length) {
          for (i = 0; i < e.d.length; i++) {
            var mo = e.d[i];
            // heeft het model eigen producttypes, dan volgt stap 3; zo niet,
            // dan is de modelcollectie zelf de bestemming
            html += (mo.t.length || !mo.h) ? row(mo.n, i, mo.h)
                                           : leaf(mo.n, mo.h, i);
          }
          if (title2) title2.textContent = '2. Kies je model';
          if (count) count.textContent = e.d.length + (e.d.length === 1 ? ' model' : ' modellen');
        } else {
          // geen modelcollecties: de producten staan hier, niet in een derde kolom
          for (i = 0; i < e.t.length; i++) html += link(e.t[i].l, e.t[i].h);
          if (title2) title2.textContent = '2. Kies je product voor ' + e.m;
          if (count) count.textContent = e.t.length + (e.t.length === 1 ? ' product' : ' producten');
        }
        if (back2) back2.textContent = 'Merken';
      } else {
        for (i = 0; i < e.b.length; i++) {
          var br = e.b[i];
          // merk met modellen krijgt een vervolgstap, anders een directe link
          html += br.d.length ? row(br.m, i, br.h)
                              : (br.h ? leaf(br.m, br.h, i) : row(br.m, i, null));
        }
        /* Bedrijfswageninrichting zet series in kolom 2 in plaats van merken,
           dus mag het producttype zijn eigen labels meegeven. */
        var w2 = e.w2 || ['merk', 'merken'];
        if (title2) title2.textContent = '2. ' + (e.l2 || 'Kies je merk');
        if (count) count.textContent = e.b.length + ' ' + (e.b.length === 1 ? w2[0] : w2[1]);
        if (back2) back2.textContent = e.l;
      }

      // Onder de lijst: past er niets, dan alles van de vorige keuze. Staat
      // achteraan omdat je eerst de specifieke opties scant. Op touch is dit
      // ook de enige manier om bij de bestemming van stap 1 te komen.
      var root = isBrands ? e.h : e.r;
      if (root) {
        html += allLink(isBrands ? ('Alles van ' + e.m) : ('Alle ' + e.l.toLowerCase()), root);
      }

      rows2.innerHTML = html;
      state.b = 0;
      mark(rows2, 0);
      fill3();
    }

    function fill3() {
      syncCols();
      if (!hasStep3()) return;

      var e = entries[state.a];
      var html = '', title = '', i;

      if (isBrands) {
        var model = e.d[Math.min(state.b, e.d.length - 1)];
        if (model) {
          title = '3. Kies je product voor ' + e.m + ' ' + model.n;
          if (back3) back3.textContent = model.n;
          for (i = 0; i < model.t.length; i++) html += link(model.t[i].l, model.t[i].h);
          if (model.h) html += allLink('Alles voor de ' + model.n, model.h);
        }
      } else {
        var brand = e.b[state.b];
        if (brand) {
          title = '3. ' + (e.l3 || 'Kies je model') + ' voor ' + brand.m;
          if (back3) back3.textContent = brand.m;
          for (i = 0; i < brand.d.length; i++) html += link(brand.d[i].n, brand.d[i].h);
          if (brand.h) {
            html += allLink(e.l3 ? ('Alles van ' + brand.m)
                                 : ('Alle ' + e.l.toLowerCase() + ' van ' + brand.m), brand.h);
          }
        }
      }

      rows3.innerHTML = html;
      if (title3) title3.textContent = title;
    }

    function pick1(i, advance) {
      if (i === state.a && !advance) return;
      state.a = i;
      mark(rows1, i);
      fill2();
      if (advance) showStep(2);
    }

    function pick2(i, advance) {
      if (i === state.b && !advance) return;
      state.b = i;
      mark(rows2, i);
      fill3();
      if (advance) showStep(3);
    }

    rows1.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-mmb-' + (isBrands ? 'brand' : 'type') + ']');
      if (!t) return;
      if (followLink(t)) return;      // de link doet wat hij belooft
      ev.preventDefault();
      pick1(Number(t.dataset[attr1]), true);
    });

    rows2.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-mmb-pick]');
      if (!t) return;                 // een leaf-rij is een gewone link
      if (followLink(t)) return;
      ev.preventDefault();
      pick2(Number(t.dataset.mmbPick), true);
    });

    // hover alleen waar het werkt: desktop met een echte cursor
    if (window.matchMedia('(hover: hover)').matches) {
      rows1.addEventListener('mouseover', function (ev) {
        if (mobile.matches) return;
        var t = ev.target.closest('[data-mmb-' + (isBrands ? 'brand' : 'type') + ']');
        if (t) pick1(Number(t.dataset[attr1]), false);
      });
      rows2.addEventListener('mouseover', function (ev) {
        if (mobile.matches) return;
        var t = ev.target.closest('[data-mmb-pick],[data-mmb-leaf]');
        if (!t) return;
        var i = Number(t.dataset.mmbPick !== undefined ? t.dataset.mmbPick : t.dataset.mmbLeaf);
        pick2(i, false);
      });
    }

    // terug binnen het paneel. De knop in stap 1 heeft .js-back en wordt door
    // het thema afgehandeld: die sluit het paneel.
    panel.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-mmb-back]');
      if (!b) return;
      ev.preventDefault();
      ev.stopPropagation();
      showStep(Math.max(1, state.step - 1));
    });

    // paneel opnieuw openen begint weer bij stap 1
    var disclosure = panel.closest('details');
    if (disclosure) {
      var summary = disclosure.querySelector('summary');
      if (summary) summary.addEventListener('click', function () { showStep(1); });
    }

    mobile.addEventListener('change', function () { showStep(1); });

    fill2();
    showStep(1);
  }

  function init() {
    var panels = document.querySelectorAll('[data-mmb-panel]');
    for (var i = 0; i < panels.length; i++) initPanel(panels[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
